module.exports = __webpack_public_path__ + "static/product-l0970-olive-drab-c6093c089c86b679768020527199bfd7.png";